var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalNetWorth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 168,
    viewBox: "0 0 93 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_75_1764",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 93,
    height: 168
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 167,
    rx: 15.5,
    fill: "#3E3E3E",
    stroke: "url(#paint0_linear_75_1764)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_75_1764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 60.8098V92.1899C65 110.957 52.7931 119 34.4827 119H-26.4828C-29.6039 119 -32.5862 118.756 -35.3605 118.208C-37.0944 117.964 -38.759 117.538 -40.2849 117.05C-50.6885 113.638 -57 105.717 -57 92.1899V60.8098C-57 42.0428 -44.7932 34 -26.4828 34H34.4827C50.0188 34 61.1853 39.7885 64.1677 53.0107C64.6532 55.448 65 57.946 65 60.8098Z",
    stroke: "url(#paint1_linear_75_1764)",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 79.305V110.957C86 129.887 73.81 138 55.525 138H-5.35613C-10.4815 138 -15.1219 137.385 -19.1391 136.033C-27.3812 133.329 -32.9914 127.736 -35 118.763C-32.2295 119.316 -29.2513 119.562 -26.1345 119.562H34.7466C53.0316 119.562 65.2216 111.449 65.2216 92.519V60.8667C65.2216 57.9781 64.9445 55.397 64.3904 53C77.5501 55.4584 86 63.694 86 79.305Z",
    stroke: "url(#paint2_linear_75_1764)",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 93C13.9409 93 22 85.8364 22 77.0001C22 68.1635 13.9409 61 4 61C-5.94105 61 -14 68.1635 -14 77.0001C-14 85.8364 -5.94105 93 4 93Z",
    stroke: "url(#paint3_linear_75_1764)",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 63V90",
    stroke: "url(#paint4_linear_75_1764)",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_1764",
    x1: 2.53636,
    y1: 168,
    x2: 117.325,
    y2: 149.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_1764",
    x1: -53.6727,
    y1: 119,
    x2: 77.4991,
    y2: 63.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_1764",
    x1: -31.7,
    y1: 138,
    x2: 98.7191,
    y2: 83.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_1764",
    x1: -13.0182,
    y1: 93,
    x2: 28.0888,
    y2: 79.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_1764",
    x1: 43.0273,
    y1: 90,
    x2: 44.2942,
    y2: 89.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#5CC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#BC85FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalNetWorth);
export default __webpack_public_path__ + "static/media/totalNetWorth.1cc0c2357131d4a657775c9528b9e5ed.svg";
export { ForwardRef as ReactComponent };